import apiClient from '../api/client';

// Email-intake review queue: emails that CC iotmtandt@mtandt.com announcing a
// machine de-hire / mobilisation / maintenance are parsed (no AI) on the server
// and staged here for a super-admin to approve before any status actually changes.
const emailIntakeService = {
    // status: PENDING | APPLIED | REJECTED | FAILED | ALL
    list: async (status = 'PENDING') => {
        const q = status ? `?status=${encodeURIComponent(status)}` : '';
        return await apiClient.get(`/email-intake${q}`);
    },

    // Read the inbox now and stage any new requests.
    sync: async () => {
        return await apiClient.post('/email-intake/sync');
    },

    // Apply the machine status change. payload: { equipmentId, toStatus, effectiveDate, opening }
    approve: async (id, payload) => {
        return await apiClient.post(`/email-intake/${id}/approve`, payload);
    },

    reject: async (id, note) => {
        return await apiClient.post(`/email-intake/${id}/reject`, { note });
    },
};

export default emailIntakeService;
